<ng-template #tplLink let-node=node>
  <a
    (click)="clickNavItem(node)"
    [class.current]="isCurrent(node)"
    [link]="node"
    uiNavLink
  >
    {{ node.label }}
    @if (node.description) {
      <small class="subtext">{{ node.description }}</small>
    }
  </a>
</ng-template>

<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="upkeep-navigation">
  <mat-tree-node *matTreeNodeDef="let node" class="mat-tree-node" matTreeNodeToggle>
    <ng-container *ngTemplateOutlet="tplLink; context: { node }"></ng-container>
  </mat-tree-node>

  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" class="mat-tree-node">
    <div class="link-container">
      <ng-container *ngTemplateOutlet="tplLink; context: { node }"></ng-container>

      <button
        [attr.aria-expanded]="treeControl.isExpanded(node)"
        [attr.aria-label]="'Toggle ' + node.label"
        mat-icon-button
        matTreeNodeToggle>
        <ui-icon [faName]="treeControl.isExpanded(node) ? 'chevron-up' : 'chevron-down'" [faStyle]="'light'"></ui-icon>
      </button>
    </div>

    @if (treeControl.isExpanded(node)) {
      <div
        [@slideVertical]="treeControl.isExpanded(node) ? 'show' : null"
        class="tree-list"
        role="group">
        <ng-container matTreeNodeOutlet></ng-container>
      </div>
    }
  </mat-nested-tree-node>
</mat-tree>
